import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiasEnCargaDescargaZE as Comp } from "./comp";

export interface Props {
    idDescargaZE: number;
}

/**Toma el idCargaDescarga y muestra las guias incluidas */
export class GuiasEnDescargaZE extends React.PureComponent<Props> {
    idDescargaZE = (props: Props) => props.idDescargaZE;
    guias = createSelectorRx(this.idDescargaZE, idDescargaZE => observeResource(resources.DescargaZE.ObtenerGuiasEnDescargaZE, idDescargaZE));

    onQuitarGuia = async (x: models.GuiaDTO) => {
        const idDescargaZE = this.props.idDescargaZE;
        await resources.DescargaZE.QuitarGuia(idDescargaZE, x.IdRegistro);
    }

    render() {
        const guias = this.guias(this.props);
        return <Comp value={guias} onQuitarGuia={this.onQuitarGuia} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/edit/status/items/guias/index.tsx